import { useState, useRef, useCallback, useEffect } from "react"

export const fadeOutMenuDelay = 100
export const fadeOutMenuDuration = 150

export function useFadeOutMenu(
    delay: number = fadeOutMenuDelay,
    duration: number = fadeOutMenuDuration
) {
    const [menuIsOpen, setMenuIsOpen] = useState(false)
    const [menuIsFading, setMenuIsFading] = useState(false)
    const menuMouseLeaveTimeout = useRef<NodeJS.Timeout | null>(null)
    const cancelMenuMouseLeaveTimeout = useCallback(() => {
        if (menuMouseLeaveTimeout.current) clearTimeout(menuMouseLeaveTimeout.current)
    }, [])
    const menuFadeOutTimer = useRef<NodeJS.Timeout | null>(null)
    const cancelMenuFadeOutTimer = useCallback(() => {
        if (menuFadeOutTimer.current) clearTimeout(menuFadeOutTimer.current)
    }, [])
    const openMenu = useCallback(() => {
        cancelMenuMouseLeaveTimeout()
        cancelMenuFadeOutTimer()
        setMenuIsOpen(true)
        setMenuIsFading(false)
    }, [cancelMenuMouseLeaveTimeout, cancelMenuFadeOutTimer])
    const closeMenu = useCallback(() => {
        menuMouseLeaveTimeout.current = setTimeout(() => {
            setMenuIsOpen(false)
            setMenuIsFading(true)
        }, delay)
    }, [delay])
    useEffect(() => {
        if (menuIsFading) {
            menuFadeOutTimer.current = setTimeout(() => {
                setMenuIsFading(false)
            }, duration)
        } else {
            cancelMenuFadeOutTimer()
        }
    }, [cancelMenuFadeOutTimer, duration, menuIsFading])
    return {
        openMenu,
        menuIsOpen,
        menuIsFading,
        closeMenu,
    }
}
